import ApprovalsList from './approvals_list.vue';
export default {
    name: 'ApprovalsFooter',
    components: {
        ApprovalsList
    },
    props: {
        codeCoverageCheckHelpPagePath: {
            type: String,
            required: false,
            default: ''
        },
        eligibleApproversDocsPath: {
            type: String,
            required: false,
            default: ''
        },
        projectPath: {
            type: String,
            required: true
        },
        iid: {
            type: String,
            required: true
        }
    }
};
